import React from "react";

/**
 * Invoice Table Skeleton Loader
 * Provides skeleton loading state for the invoice table during initial data fetch
 */
export const InvoiceTableSkeleton = ({ rows = 5, showUserColumn = true }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <tr key={`skeleton-${index}`} style={{ borderBottom: "0.5px solid #D8DDE1" }}>
          {/* Checkbox column */}
          <td style={{ width: "50px", maxWidth: "100px", textAlign: "center", paddingRight: "20px", paddingLeft: "22px", paddingTop: "19px", paddingBottom: "22px" }} className="fixed-se">
            <div
              style={{
                width: "18px",
                height: "18px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
                margin: "0 auto",
              }}
            />
          </td>
          
          {/* Invoice ID */}
          <td className="fixed-sec" style={{ paddingRight: "44px", paddingTop: "19px", paddingBottom: "22px" }}>
            <div
              style={{
                width: "80px",
                height: "20px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* User Name (conditional) */}
          {showUserColumn && (
            <td className="fixed-se1" style={{ paddingRight: "35px", maxWidth: "230px", minWidth: "230px", width: "230px", paddingTop: "19px", paddingBottom: "22px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    backgroundColor: "#e5e7eb",
                    borderRadius: "50%",
                    animation: "pulse 1.5s ease-in-out infinite",
                  }}
                />
                <div
                  style={{
                    width: "120px",
                    height: "16px",
                    backgroundColor: "#e5e7eb",
                    borderRadius: "4px",
                    animation: "pulse 1.5s ease-in-out infinite",
                  }}
                />
              </div>
            </td>
          )}
          
          {/* CTA column */}
          <td className="fixed-sec2" style={{ paddingRight: "45px", minWidth: "121.73px", paddingTop: "19px", paddingBottom: "22px" }}>
            <div
              style={{
                width: "60px",
                height: "24px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* Due Date */}
          <td className="fixed-sec3" style={{ paddingRight: "44px", paddingTop: "19px", paddingBottom: "22px" }}>
            <div
              style={{
                width: "100px",
                height: "20px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* Status */}
          <td style={{ paddingRight: "44px", paddingTop: "19px", paddingBottom: "22px" }}>
            <div
              style={{
                width: "80px",
                height: "24px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* Payment Status */}
          <td style={{ paddingRight: "44px", paddingTop: "19px", paddingBottom: "22px" }}>
            <div
              style={{
                width: "100px",
                height: "24px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* Amount */}
          <td style={{ paddingRight: "44px", paddingTop: "19px", paddingBottom: "22px" }}>
            <div
              style={{
                width: "90px",
                height: "20px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* Creation Date */}
          <td style={{ paddingRight: "44px", paddingTop: "19px", paddingBottom: "22px" }}>
            <div
              style={{
                width: "100px",
                height: "20px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* Created By */}
          <td style={{ paddingRight: "44px", maxWidth: "230px", minWidth: "230px", width: "230px", paddingTop: "19px", paddingBottom: "22px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <div
                style={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: "#e5e7eb",
                  borderRadius: "50%",
                  animation: "pulse 1.5s ease-in-out infinite",
                }}
              />
              <div
                style={{
                  width: "100px",
                  height: "16px",
                  backgroundColor: "#e5e7eb",
                  borderRadius: "4px",
                  animation: "pulse 1.5s ease-in-out infinite",
                }}
              />
            </div>
          </td>
          
          {/* Updated By */}
          <td style={{ paddingRight: "44px", maxWidth: "230px", minWidth: "230px", width: "230px", paddingTop: "19px", paddingBottom: "22px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <div
                style={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: "#e5e7eb",
                  borderRadius: "50%",
                  animation: "pulse 1.5s ease-in-out infinite",
                  flexShrink: 0,
                }}
              />
              <div
                style={{
                  width: "100px",
                  height: "16px",
                  backgroundColor: "#e5e7eb",
                  borderRadius: "4px",
                  animation: "pulse 1.5s ease-in-out infinite",
                }}
              />
            </div>
          </td>
          
          {/* Paid Date */}
          <td style={{ paddingRight: "44px", paddingTop: "19px", paddingBottom: "22px" }}>
            <div
              style={{
                width: "100px",
                height: "20px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* Recipient */}
          <td style={{ paddingRight: "44px", paddingTop: "19px", paddingBottom: "22px" }}>
            <div
              style={{
                width: "60px",
                height: "20px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* App */}
          <td style={{ paddingRight: "44px", paddingTop: "19px", paddingBottom: "22px" }}>
            <div
              style={{
                width: "40px",
                height: "40px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
        </tr>
      ))}
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </>
  );
};

/**
 * Invoice Filters Skeleton Loader
 * Provides skeleton loading state for filter controls
 */
export const InvoiceFiltersSkeleton = () => {
  return (
    <div
      role="status"
      aria-label="Loading filters"
      style={{
        display: "flex",
        gap: "12px",
        padding: "16px",
        flexWrap: "wrap",
      }}
    >
      {/* Filter buttons skeleton */}
      {[1, 2, 3, 4, 5].map((i) => (
        <div
          key={i}
          style={{
            width: "120px",
            height: "40px",
            backgroundColor: "#e5e7eb",
            borderRadius: "6px",
            animation: "pulse 1.5s ease-in-out infinite",
          }}
        />
      ))}
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </div>
  );
};

